import moment from 'moment';
import { NumberHelper } from '../../../helpers/NumberHelper';
import { constants } from '../../../config';

export const columnsCredit = [
  {
    Header: 'Fecha',
    accessor: 'date',
    Cell: (value) => {
      const date = value && moment(value).isValid() && moment(value).format(constants.dateFormat);
      return date;
    },
  },
  {
    Header: 'Factura',
    accessor: 'number',
  },
  {
    Header: 'Importe',
    accessor: 'amount',
    Cell: value => NumberHelper.formatPrice(value),
    typeCell: 'currency',
  },
  {
    Header: 'Plan',
    accessor: 'plan',
  },
  {
    Header: 'Vencimiento',
    accessor: 'nextDue',
    Cell: (value) => {
      const date = value && moment(value).isValid() && moment(value).format(constants.dateFormat);
      return date;
    },
  },
  {
    Header: 'Saldo',
    accessor: 'balance',
    Cell: value => value && NumberHelper.formatPrice(value),
    typeCell: 'currency',
  },
  {
    Header: 'Último pago',
    accessor: 'lastPayment',
    Cell: (value) => {
      const date = value && moment(value).isValid() && moment(value).format(constants.dateFormat);
      return date;
    },
  },
  {
    Header: 'Cuotas',
    accessor: 'schemaPayments',
  },
];

export const columnsPayments = [
  {
    Header: 'Fecha de pago',
    accessor: 'datePay',
    Cell: (value) => {
      const date = value && moment(value).isValid() && moment(value).format(constants.dateFormat);
      return date;
    },
  },
  {
    Header: 'Recibo de pago',
    accessor: 'paymentTicket',
  },
  {
    Header: 'Importe total',
    accessor: 'amount',
    Cell: value => value && NumberHelper.formatPrice(value),
    typeCell: 'currency',
  },
];



// WEBPACK FOOTER //
// ./src/pages/my-account/my-credit/config.js